var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.5H15C15.3978 22.5 15.7794 22.342 16.0607 22.0607C16.342 21.7794 16.5 21.3978 16.5 21C16.5 20.6022 16.342 20.2206 16.0607 19.9393C15.7794 19.658 15.3978 19.5 15 19.5H10.5C10.1022 19.5 9.72064 19.658 9.43934 19.9393C9.15804 20.2206 9 20.6022 9 21C9 21.3978 9.15804 21.7794 9.43934 22.0607C9.72064 22.342 10.1022 22.5 10.5 22.5ZM28.5 7.5H7.5C6.30653 7.5 5.16193 7.97411 4.31802 8.81802C3.47411 9.66193 3 10.8065 3 12V25.5C3 26.6935 3.47411 27.8381 4.31802 28.682C5.16193 29.5259 6.30653 30 7.5 30H28.5C29.6935 30 30.8381 29.5259 31.682 28.682C32.5259 27.8381 33 26.6935 33 25.5V12C33 10.8065 32.5259 9.66193 31.682 8.81802C30.8381 7.97411 29.6935 7.5 28.5 7.5ZM30 25.5C30 25.8978 29.842 26.2794 29.5607 26.5607C29.2794 26.842 28.8978 27 28.5 27H7.5C7.10218 27 6.72064 26.842 6.43934 26.5607C6.15804 26.2794 6 25.8978 6 25.5V16.5H30V25.5ZM30 13.5H6V12C6 11.6022 6.15804 11.2206 6.43934 10.9393C6.72064 10.658 7.10218 10.5 7.5 10.5H28.5C28.8978 10.5 29.2794 10.658 29.5607 10.9393C29.842 11.2206 30 11.6022 30 12V13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.0817e29cebdbe8021ea10833f04d8ab0.svg";
export { ForwardRef as ReactComponent };